import { gql } from '@apollo/client';
import type { DailyTaskSummaryAreaListData } from './getDailyTaskSummaryAreaList';

// DSP 用户专用：与 WHS/Hub 版同字段，仅替换 operation 名为 ForDsp 版本
export const GET_DSP_DAILY_TASK_SUMMARY_AREA_LIST = gql`
  query GetDailyTaskSummaryAreaListForDsp(
    $taskDate: String!
    $hubId: Long
    $warehouseId: Long
    $warehouseIds: [Long!]
    $dspIds: [Long!]
    $areaIds: [Long!]
    $cities: [String!]
    $dimensionType: String
    $pageRequest: DailyTaskPageRequestTypeInput!
  ) {
    getDailyTaskSummaryAreaListForDsp(
      taskDate: $taskDate
      hubId: $hubId
      warehouseId: $warehouseId
      warehouseIds: $warehouseIds
      dspIds: $dspIds
      areaIds: $areaIds
        cities: $cities
        dimensionType: $dimensionType
        pageRequest: $pageRequest
    ) {
      calculatedAt
      summaryData {
        deliveryProgress {
          scheduledParcels
          actualPickedUp
          deliveredParcels
          pickupRate
          deliveryRate
        }
        undeliveredDistribution {
          totalUndelivered
          unpicked
          inDelivery
          failedReturned
          failedNotReturned
          warehouseLost
        }

      }
      recordData {
        id
        taskDate
        warehouseId
        warehouseName
        dspId
        dspName
        areaId
        areaName
        allocatedParcels
        pickedUpFromWarehouse
        warehouseLost
        inDelivery
        onTimeDelivery
        overdueDelivery
        deliveredCount
        unclaimedCount
        noAscanDelivery
        transferredIn
        transferredOut
        returned
        damaged
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface GetDspDailyTaskSummaryAreaListResponse {
  getDailyTaskSummaryAreaListForDsp: DailyTaskSummaryAreaListData;
}
